import React, { useContext } from 'react'
import { ItemType, LifeCycle, Priority, Progress, TodoContext } from './Project';
import Todo from './Todo';

export default function TodoBacklog() {
  const {tasks, setTasks} = useContext(TodoContext);
  const lines = tasks.filter(task => task.priority === Priority.Backlog);

  const add = (e) => {
    setTasks([{
        id: crypto.randomUUID(),
        text: `?`,
        priority: Priority.Backlog,
        lifeCycle: LifeCycle.Code,
        progress: Progress.Pending,
        itemType: ItemType.Task,
        kiponosInfo: {isNew:true}    
    }, ...tasks]);
  }

  return ( <Todo title='Backlog' lines={lines} titleStyle='titleBacklog' anAdd={add}/> );
}
